import { ShieldCheck, Lock } from "lucide-react";

// Top-of-dialog note: who can edit message templates + current user's access.
export const TemplateAccessNote = ({ canEdit, testid }) => (
  <div className={`rounded-lg border px-3 py-2 text-xs flex flex-wrap items-center gap-2 ${canEdit ? "bg-emerald-50 border-emerald-200 text-emerald-900" : "bg-amber-50 border-amber-200 text-amber-900"}`} data-testid={testid}>
    {canEdit ? <ShieldCheck className="w-4 h-4" /> : <Lock className="w-4 h-4" />}
    <span><b>Editable by:</b> Super Admin · Location Admin · Manager</span>
    <span className="ml-auto font-bold" data-testid={`${testid}-status`}>{canEdit ? "You can edit" : "View only"}</span>
  </div>
);
